export const customConfig = {
    'name': '客户',
    'value': 'customerName',
    'advanceConfig': [
        { 'prop': 'ebcuNameCn', 'value': '客户名称' },
        { 'prop': 'pmCode', 'value': '客户编码' }
    ],
    'tableConfig': [
        { 'prop': 'pmCode', 'value': '客户编码' },
        { 'prop': 'ebcuNameCn', 'value': '客户名称' }
    ],
    'advanceUrl': '/ebCustomer/searchByEbCustomer',
    'cbParams': [ 'pmCode#customerCode', 'ebcuNameCn#customerName' ]
};